import { GenericFilter } from '@energybox/react-ui-library/dist/components';
import { EquipmentType } from '@energybox/react-ui-library/dist/types';
import { isDefined } from '@energybox/react-ui-library/dist/utils';
import React from 'react';
import { useEquipmentTypesById } from '../../../hooks/useEquipmentTypes';

type Props = {
  selectedEquipmentTypeIds: number[];
  setFilters: (selectedIds: number[]) => void;
  equipmentTypes: Partial<EquipmentType>[];
  className?: string;
  disabled?: boolean;
  alignItemsRight?: boolean;
};

const EquipmentTypeFilter = ({
  selectedEquipmentTypeIds,
  setFilters,
  equipmentTypes,
  className,
  disabled,
  alignItemsRight,
}: Props) => {
  const equipmentTypesById = useEquipmentTypesById();

  return (
    <GenericFilter
      className={className}
      title="Equipment Type"
      setFilter={setFilters}
      items={equipmentTypes.map(({ id }) => id || NaN)}
      selectedItems={selectedEquipmentTypeIds}
      transformItemName={(equipmentTypeId) => {
        const type = equipmentTypesById[equipmentTypeId];
        return isDefined(type) ? type.title : '';
      }}
      disabled={disabled}
      alignItemsRight={alignItemsRight}
    />
  );
};

export default EquipmentTypeFilter;
